import useAxios from "../../hooks/useAxios";

const useMaintenanceService = () => {
  const axiosStatus = useAxios();
  const axiosToggle = useAxios();

  const getMaintenanceStatus = async () => {
    return await axiosStatus.fetchData({
      url: "/maintenance/status",
      method: "GET",
    });
  };

  const toggleMaintenance = async (enabled) => {
    return await axiosToggle.fetchData({
      url: "/maintenance/toggle",
      method: "POST",
      data: { enabled },
    });
  };

  return {
    getMaintenanceStatus,
    statusLoading: axiosStatus.loading,
    statusResponse: axiosStatus.response,
    statusError: axiosStatus.error,
    toggleMaintenance,
    toggleLoading: axiosToggle.loading,
    toggleError: axiosToggle.error,
  };
};

export default useMaintenanceService;
